import { createClient } from '@supabase/supabase-js'

const isLocal = window.location.href.includes('localhost')
const supabaseUrl = isLocal ? process.env.REACT_APP_SUPABASE_URL : process.env.REACT_APP_SUPABASE_URL_PROD
const supabaseAnonKey = isLocal ? process.env.REACT_APP_SUPABASE_ANON_KEY : process.env.REACT_APP_SUPABASE_ANON_KEY_PROD

export const supabase = createClient(supabaseUrl, supabaseAnonKey)